import { BrowserRouter, Routes, Route } from "react-router-dom";
//imports from mobile code
import SplashScreen from "../../../Diathrive/src/containers/SplashScreen";
//imports from web code
import LoginFlow from "../containers/LoginFlow";
import SignUp from "../containers/SignUp";
import Layout from "../containers/Layout";
import Text from "../../../Diathrive/src/components/elements/Text";
import Resources from "../../../Diathrive/src/containers/Resources";
import RequestUniqueID from "../containers/RequestUniqueID";
import Settings from "../containers/Settings";
import ForgotPassword from "../containers/ForgotPassword";
import ShoppingStore from "../containers/ShoppingStore";
import ParentRoute from "../containers/ParentRoute";
import HomeLayout from "../containers/Home";
import ShippingAddresses from "../containers/ShippingAddresses";
import Checkout from "../containers/CheckoutFlow";
import ViewResource from "../../../Diathrive/src/containers/ViewResource";
import ContactSupportFlow from "../containers/ContactSupportFlow";
import ViewCompleteHistoryWeb from "../containers/ViewCompleteHistoryWeb";
import SalesforceChatVisibilityDecider from "../containers/SalesforceChatVisibilityDecider";
import Advising from "../containers/Advising";

const Router = ({ takeToLogin }) => {
  //passing the prop forward
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<SalesforceChatVisibilityDecider />}>
          <Route element={<ParentRoute takeToLogin={takeToLogin} />}>
            <Route path="/" element={<SplashScreen />} />
            <Route element={<Layout />}>
              <Route path="/home" element={<HomeLayout />} />
              <Route
                path="/blood-sugar-readings"
                element={<HomeLayout ViewBSHistory={true} />}
              />
              <Route
                path="/view-all-readings"
                element={<ViewCompleteHistoryWeb />}
              />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/store" element={<ShoppingStore />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/advising" element={<Advising />} />
              <Route path="/contact-support" element={<ContactSupportFlow />} />
              <Route path="/my-addresses" element={<ShippingAddresses />} />
              <Route path="/resource-details" element={<ViewResource />} />
            </Route>
          </Route>
          <Route path="/login" element={<LoginFlow />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/request-unique-id" element={<RequestUniqueID />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
export default Router;
